<mat-form-field class="z-input-smaller z-input-rounded" [class.z-grey]="space">
  <mat-icon matPrefix>action_find</mat-icon>

  <mat-label><ng-content></ng-content></mat-label>

  <input #inputField matInput autocomplete="off" [value]="value" (input)="emit($event)" />
</mat-form-field>
